import { Box, Paper, Popper } from "@mui/material";
import { useState } from "react";
import useAPI from "../api/hooks/useAPI";

const TooltipWrapper = ({
  children,
  content,
  style = undefined,
  name = undefined,
  width = "230px",
  padding = "16px",
  placement = "right",
}) => {
  const { trackEvent } = useAPI();

  const [anchorEl, setAnchorEl] = useState(null);
  const [toolTipStartTimer, setToolTipStartTimer] = useState(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleTooltipOpen = (event) => {
    setAnchorEl(event.currentTarget);
    // Start the timer when the tooltip opens
    setToolTipStartTimer(new Date());
    setIsTooltipOpen(true);
  };

  const handleTooltipClose = () => {
    setAnchorEl(null);
    if (toolTipStartTimer) {
      // Calculate the time the tooltip was open
      const timeHovered = new Date() - toolTipStartTimer;
      // Track the time the tooltip was open in seconds
      if (name) {
        trackEvent(name + " Open Duration: " + timeHovered / 1000 + "s");
      } else {
        trackEvent("Open Tooltip Duration: " + timeHovered / 1000 + "s");
      }
      // Reset the timer
      setToolTipStartTimer(null);
    }
    setIsTooltipOpen(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? "custom-tooltip" : undefined;

  return (
    <Box onMouseOver={handleTooltipOpen} onMouseOut={handleTooltipClose}>
      {children}
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement={placement}
        sx={style}
      >
        <Paper sx={{ padding: padding, width: width }}>{content}</Paper>
      </Popper>
    </Box>
  );
};

export default TooltipWrapper;
